import QANewquery from "./qanewquery";

export default QANewquery;
